{
  "salon-search-form-advance-dialog": {
    "buttons": {
      "cancel": "Cancel",
      "save": "Save"
    },
    "text": {
      "title": "Advance filter",
      "kilometer": "Kilometers",
      "only-salon-with-discount": "Discount only",
      "only-salon-with-discount-description": "Show only salon with discounted services",
      "radius": "Radius",
      "radius-description": "How far the salons should be from the desired location",
      "sort-by": "Sort by",
      "sort-by-distance": "Distance",
      "sort-by-distance-description": "The nearest salon to the desired location will be shown first",
      "sort-by-rating": "Rating",
      "sort-by-rating-description": "The best rating salon will be shown first"
    }
  }
}
